import AppStoreBadge from './AppStoreBadge';
import shot1 from '../images/screenshots/shot-1.png';
import shot3 from '../images/screenshots/shot-3.png';
import shot4 from '../images/screenshots/shot-4.png';

export default function Hero() {
  return (
    <section className="hero" id="top">
      <div className="container hero-grid">
        <div className="hero-copy">
          <span className="eyebrow">🎙️ Voice translator · iOS</span>
          <h1>
            Speak the world's <span className="gradient-text">languages</span>.
          </h1>
          <p className="lead">
            Press, talk, release — and Klingua speaks back, instantly, in any of
            9 languages. Real conversations, no typing.
          </p>
          <div className="hero-cta">
            <AppStoreBadge />
            <a className="btn btn-ghost" href="#how">See how it works</a>
          </div>
          <div className="rating">
            <span className="stars">★★★★★</span>
            <span><b>5.0</b> on the App Store · Free on iPhone &amp; iPad</span>
          </div>
        </div>

        <div className="hero-art" aria-hidden="true">
          <span className="blob" style={{ width: 260, height: 260, background: 'rgba(30,167,230,.35)', left: '8%', top: '12%' }} />
          <span className="blob" style={{ width: 220, height: 220, background: 'rgba(251,59,52,.28)', right: '4%', bottom: '6%' }} />
          <div className="phone p2"><img src={shot4} alt="" /></div>
          <div className="phone p3"><img src={shot3} alt="" /></div>
          <div className="phone p1"><img src={shot1} alt="Klingua app screenshot" /></div>
        </div>
      </div>
    </section>
  );
}
